import { SET_SELECTED_ITEM, SET_RELATIONS, SET_SOURCES, SET_TABLES, SET_SOURCE_TABLES_LOADING, SET_SOURCE_TABLES, SET_ENTITY_RELATIONS_LOADING, SET_ENTITY_RELATIONS } from './mutation-types';
import {axiosClient} from '@/core/services/http.service';

export const selectItem = ({ commit }, { item, type }) => {
  commit(SET_SELECTED_ITEM, { item, type });

  localStorage.setItem('selectedType', type);
  localStorage.setItem('selectedName', type === 'source' ? item.name : item.displayName);
};

export const getTableRelations = ({ commit }, tableName) => {
  // Simulate server delay
  return new Promise(resolve => {
    const mockedRelations = [
      { fromTable: 'Table 1', toTable: 'Customers', sourceField: 'CustomerId', targetField: 'Id' },
      { fromTable: 'Table 1', toTable: 'Employees', sourceField: 'EmployeeId', targetField: 'Id' },
      { fromTable: 'Table 1', toTable: 'Orders', sourceField: 'OrderId', targetField: 'Id' },
      { fromTable: 'Table 1', toTable: 'Products', sourceField: 'ProductId', targetField: 'Id' },
      { fromTable: 'Table 1', toTable: 'Orders', sourceField: 'OrderId', targetField: 'Id' },
      { fromTable: 'Orders', toTable: 'Table 1', sourceField: 'CustomerId', targetField: 'Id' },
      { fromTable: 'Orders', toTable: 'Table 1', sourceField: 'EmployeeId', targetField: 'Id' },
      { fromTable: 'OrderDetails', toTable: 'Table 1', sourceField: 'OrderId', targetField: 'Id' },
      { fromTable: 'OrderDetails', toTable: 'Table 1', sourceField: 'ProductId', targetField: 'Id' },
      { fromTable: 'Invoices', toTable: 'Table 1', sourceField: 'OrderId', targetField: 'Id' },
    ];
  
    // Filter for current table (optional optimization)
    const relevant = mockedRelations.filter(
      r => r.fromTable === tableName || r.toTable === tableName,
    );
  
    commit(SET_RELATIONS, relevant);
    resolve();
  });
};

export const getSourcesAndTables =async ({ commit }) => {
  try {
    const response = await axiosClient.get('/api/DataCatalog/sources-and-tables');
    const data = response.body;
    commit(SET_SOURCES, data.sources);
    commit(SET_TABLES, data.tables);
  } catch (error) {
    console.error('Failed to fetch sources and tables:', error);
  }
};
export const fetchColumns = async ({ commit }, entityGuid) => {
  try {
    commit('SET_COLUMNS_LOADING', true);
    const response = await axiosClient.get(`/api/DataCatalog/table-columns-extended/${entityGuid}`);
    commit('SET_COLUMNS', response.body);
  } catch (error) {
    console.error('Error fetching extended table columns:', error);
    throw error;
  }
  finally {
    commit('SET_COLUMNS_LOADING', false);
  }
};
export const fetchSourceTables = async ({ commit }, entityGuids) => {
  try {
    commit(SET_SOURCE_TABLES_LOADING, true);
    const response = await axiosClient.post('/api/DataQualitySummary/validation-summary',entityGuids);
    commit(SET_SOURCE_TABLES, response.body);
  } catch (error) {
    console.error('Error fetching extended table columns:', error);
    throw error;
  }
  finally {
    commit(SET_SOURCE_TABLES_LOADING, false);
  }
};
export const getRelations = async ({commit}, entityGuid) => {
  
  commit(SET_ENTITY_RELATIONS_LOADING, true);
  const response = await axiosClient.get(`/api/DataCatalog/entity-relations/${entityGuid}`);
  commit(SET_ENTITY_RELATIONS, response.body);  
  commit(SET_ENTITY_RELATIONS_LOADING, false);
};